// src/App.js
import React, { useEffect, useState } from "react";
import { HashRouter as Router, Route, Routes, useNavigate } from "react-router-dom";
import Dashboard from "./components/Dashboard";
import AddressList from "./components/AddressList";
import ViewAddressDetailsForRequest from "./components/ViewAddressDetailsForRequest";
import Requests from "./components/Requests";
import ProcessRequest from "./components/ProcessRequest";
import RequestAddress from "./components/CreateAddressRequest.js";
import Navigation from "./components/Navigation";
import EMailList from "./components/EMailList";
import AddressForm from "./components/AddressForm.js";
import AddressDetailsForm from "./components/AddressDetailsForm.js";
import "./App.css";
import { getInfo} from "./utilities/calls.js";
import Login from "./components/Login.js";
import ServiceProviderList from "./components/ServiceProviderList.js";
import ServiceProviderProfileForm from "./components/ServiceProviderProfileForm.js";
import BeneProfileForm from "./components/BeneProfileForm.js";
import AboutUs from "./components/AboutUs.js";
import SearchList from "./components/SearchList.js";
import ContactSP from "./components/ContactSP.js";
import ServiceProviderShares from "./components/ServiceProviderShares.js";
import IndividualShares from "./components/IndividualShares.js";
import ServiceProviderNotifications from "./components/ServiceProviderNotifications.js";
import Contact from "./components/Contact.js";
import IndividualNotifications from "./components/IndividualNotifications.js";
import PrivateServiceProviders from "./components/PrivateServiceProviders.js";
import PolicyViewer from "./components/PolicyViewer.js";
import SecurityReports from "./components/SecurityReports.js"
import Header from "./components/Header.js";
import SecureContentList from "./components/SecureContentList.js";
import AddSecureContent from "./components/AddSecureContent.js";
import ViewSecuredContentForRequest from "./components/ViewSecureContentForRequest.js";
import ServiceProviderRequests from "./components/ServiceProviderRequests.js";
import VisitLink from "./components/VisitLink.js";
import VisitLinkContent from "./components/VisitLinkContent.js";
import ServiceProviderTemplates from "./components/ServiceProviderTemplates.js";
import AddTemplate from "./components/AddTemplate.js";
import ContactSPTemplate from "./components/ContactSPTemplate.js";
import StreamList from "./components/StreamList.js";
import StreamDetails from "./components/StreamDetails.js";
import PremiumGateModal from "./components/PremiumGateModal.js";
import FileManager from "./components/FileManager.js";

function App() {
  const [view, setView] = useState(localStorage.getItem(document.location.hostname + '.view'));
  const [premiumOpen, setPremiumOpen] = useState(false);
  const [lockedFeature, setLockedFeature] = useState(null);
  const [premiumUrl, setPremiumUrl] = useState(null);
  const [globalLoading, setGlobalLoading] = useState(false);

  const showPremiumModal = (feature, url) => {
    setLockedFeature(feature || null);
    setPremiumUrl(url)
    setPremiumOpen(true);
  };

  const hidePremiumModal = () => {
    setPremiumOpen(false);
    setLockedFeature(null);
  };
  const changeView = (val) => {
    if(val === "I"){
      localStorage.setItem(document.location.hostname + '.view', 'I');
      setView('I');
    } else {
      localStorage.setItem(document.location.hostname + '.view', 'S');
      setView('S');
    }
  }

  useEffect(() => {
    document.title = "JustWhere - helps you Securely Manage and Share!";
    const userId = (decodeURIComponent(getInfo("UserID")));
    if (userId == null || getInfo("IndividualID") == null) localStorage.setItem(document.location.hostname + '.loginStatus', 'LoggedOut'); else localStorage.setItem(document.location.hostname + '.loginStatus', 'LoggedIn');
  }, []);

  return (
    <Router>
      <Header val={view} viewState={changeView}/>
      <div style={{ marginTop: 5 }}>
        <Navigation showPremiumModal={showPremiumModal}
        setGlobalLoading={setGlobalLoading} />
        {globalLoading && (
        <div className="fixed top-4 right-4 text-white bg-zinc-800 px-4 py-2 rounded-xl">
          Loading...
        </div>
      )}

        <div id="loadingIcon" role="status" style={{ "position": "fixed", "top": "50%", "left": "50%", "z-index": "100", "display": "none" }}>
        <svg aria-hidden="true" class="w-8 h-8 animate-spin text-gray-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/><path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/></svg>
        <span class="sr-only">Loading...</span>
        </div>
        <Routes>
          <Route path="/" element={<Dashboard viewState={changeView} val={view} />} />
          <Route path="/address-list" element={<AddressList />} />
          <Route path="/address-details/:id" element={<AddressDetailsForm />} />
          <Route path="/viewrequestaddress-details/:requestid" element={<ViewAddressDetailsForRequest />} />
          <Route path="/CreateAddressRequest" element={<RequestAddress />} />
          <Route path="/AddAddressDetails" element={<AddressForm />} />
          <Route path="/process-request" element={<ProcessRequest />} />
          <Route path="/sharing" element={<IndividualShares />} />
          <Route path="/requests" element={<Requests />} />
          <Route path="/emaillist" element={<RequestAddress />} />
          <Route path="/contactlist" element={<EMailList />} />
          <Route path="/login" element={<Login />} />
          <Route path="/serviceProviders" element={<ServiceProviderList />} />
          <Route path="/AddServiceProviderProfile/:spid" element={<ServiceProviderProfileForm />} />
          <Route path="/AddBeneficiaryProfile/:spid" element={<BeneProfileForm />} />
          <Route path="/aboutUs" element={<AboutUs />} />
          <Route path="/search" element={<SearchList />} />
          <Route path="/contactServiceProvider/:id" element={<ContactSP />} />
          <Route path="/contactBeneficiary/:id" element={<ContactSP />} />
          <Route path="/spsharing" element={<ServiceProviderShares />} />
          <Route path="/serviceprovidernotifications" element={<ServiceProviderNotifications />} />
          <Route path="/contacts" element={<Contact/>}/>
          <Route path="/individualnotifications" element={<IndividualNotifications/>}/>
          <Route path="/privateserviceproviders" element={<PrivateServiceProviders/>}/>
          <Route path="/policies/:policyName" element={<PolicyViewer/>}/>
          <Route path="/security-report" element={<SecurityReports/>}/>
          <Route path="/securedContents" element={<SecureContentList/>}/>
          <Route path="/addsecurecontent/:id?" element={<AddSecureContent/>}/>
          <Route path="/viewsecurecontent/:requestid" element={<ViewSecuredContentForRequest />} />
          <Route path="/serviceproviderrequests" element={<ServiceProviderRequests/>}/>
          <Route path="/visitlink/:label" element={<VisitLink/>}/>
          <Route path="/visit/:individualID/:type/:contentid" element={<VisitLinkContent/>}/>
          <Route path="/serviceprovidertemplates/:spid" element={<ServiceProviderTemplates/>}/> 
          <Route path="/addtemplate/:id?" element={<AddTemplate/>}/>
          <Route path="/connectsptemplate/:id/:templateid" element={<ContactSPTemplate/>}/>
          <Route path="/documents" element={<StreamList/>}/>
          <Route path="/documentdetails/:id?" element={<StreamDetails/>}/>
          <Route path="/filemanager/serviceprovider/:spId/:storeId" element={<FileManager />} />
        </Routes>
        <PremiumGateModal
        open={premiumOpen}
        feature={lockedFeature}
        url={premiumUrl}
        onClose={hidePremiumModal}
        />
      </div>
    </Router>
  );
}
export default App;
